// ============================================
// Product Details Block V2 — JS
// Handles: purchase card bridge, quantity cards,
// price calculation, frequency display
// ============================================

(function () {
  'use strict';

  // ── Pricing Data ──
  // Sourced from the Liquid-generated window.V2_PRICING object
  // (see snippets/product-details-block-v2.liquid).
  // Read inside init() — not at eval time — so a swapped-in buy box can
  // publish a new pricing object and re-init picks it up.
  var PRICING = {};

  // ── Helpers ──
  function getProductType() {
    var buyBox = document.querySelector('.v2-buy-box');
    if (buyBox && buyBox.dataset.productType) return buyBox.dataset.productType;
    return 'shots';
  }

  function isSubscribe() {
    return document.querySelector('.v2-subscribe-card.selected') !== null;
  }

  function getSelectedQty() {
    var sel = document.querySelector('.v2-qty-card.selected');
    return sel ? parseInt(sel.getAttribute('data-qty'), 10) : 1;
  }

  function getTier(qty) {
    var tiers = PRICING.tiers;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min && qty <= tiers[i].max) return tiers[i];
    }
    return tiers[tiers.length - 1];
  }

  // ── Cached DOM References ──
  // Populated once in init(). These elements are static and never replaced,
  // so we avoid redundant querySelector calls on every price update / sync.
  var _els = {};

  // ── ATC Observer State ──
  // Shared between guardATCButton and updateAllPrices to prevent
  // the MutationObserver feedback loop (mutation -> callback -> DOM write -> mutation).
  var _atcObserver = null;
  var _atcObserverBtn = null;
  var _atcObserverConfig = { childList: true, characterData: true, subtree: true };
  var _isATCUpdating = false;
  var _formGuardObserver = null;
  var _docCloseBound = false;

  // ── Selling Plan Sync ──
  // ReCharge widget injects radio inputs with name="selling_plan_<ID>" and
  // a dropdown that may or may not have name="selling_plan". We must control
  // ALL selling-plan-related elements to prevent conflicts.
  // This is called reactively by the MutationObserver in initFormGuard()
  // whenever ReCharge injects elements, and as a final guard on form submit.
  function syncSellingPlan(purchaseType) {
    var form = _els.form;
    if (!form) return;

    var ourSelect = _els.ourSelect;

    // Find ALL elements whose name is or starts with "selling_plan"
    var spInputs = form.querySelectorAll('[name="selling_plan"], [name^="selling_plan_"]');
    spInputs.forEach(function (el) {
      if (el === ourSelect) return; // handle our select separately
      el.disabled = true;
      el.removeAttribute('name');
    });

    if (ourSelect) {
      if (purchaseType === 'one-time') {
        ourSelect.disabled = true;
        ourSelect.removeAttribute('name');
      } else {
        ourSelect.disabled = false;
        ourSelect.setAttribute('name', 'selling_plan');
      }
    }
  }

  function syncSellingPlanFrequency(freq) {
    var sellingPlanMap = {
      'Monthly': 'Delivery every 1 Month',
      'Every 3-Months': 'Delivery every 3 Months',
      'Every 5-Months': 'Delivery every 5 Months'
    };
    var planLabel = sellingPlanMap[freq];
    if (!planLabel) return;

    // Update our select
    var ourSelect = _els.ourSelect;
    if (ourSelect) {
      var planOptions = ourSelect.querySelectorAll('option');
      planOptions.forEach(function (opt) {
        if (opt.getAttribute('data-plan-option') === planLabel) {
          ourSelect.value = opt.value;
        }
      });
    }
  }

  // ── Price Update Engine ──
  function updateAllPrices() {
    var qty = getSelectedQty();
    var sub = isSubscribe();
    var tier = getTier(qty);
    var data = PRICING;

    var unitPrice = sub ? tier.price : data.base;
    var total = (unitPrice * qty).toFixed(2);

    var subCard = document.querySelector('.v2-subscribe-card');
    if (subCard) {
      var pctEl = subCard.querySelector('.v2-offer-pct');
      var offerPriceEl = subCard.querySelector('.v2-offer-price');
      var perUnitEl = subCard.querySelector('.v2-card-per-unit');
      if (pctEl) pctEl.textContent = tier.discount + '% off';
      if (offerPriceEl) offerPriceEl.textContent = '$' + tier.price.toFixed(2);
      if (perUnitEl) perUnitEl.textContent = '$' + tier.perUnit.toFixed(2) + '/' + data.unit;
    }

    // Update ATC button — disconnect observer around DOM writes
    // to prevent the mutation -> callback -> mutation feedback loop.
    var btn = _els.atcBtn;
    if (btn) {
      var label = sub ? 'Subscribe' : 'Add to Cart';
      var qtyWords = ['One', 'Two', 'Three', 'Four', 'Five', 'Six'];
      var qtyLabel = '(' + (qtyWords[qty - 1] || qty) + ' ' + data.packUnit + (qty > 1 ? 's' : '') + ')';
      _isATCUpdating = true;
      if (_atcObserver) _atcObserver.disconnect();

      var atcText = btn.querySelector('.v2-atc-text');
      var atcQty = btn.querySelector('.v2-atc-qty');
      var cartTotal = btn.querySelector('.v2-cart-total');

      if (atcText && atcQty && cartTotal) {
        atcText.textContent = label;
        atcQty.textContent = qtyLabel;
        cartTotal.textContent = '$' + total;
      } else {
        // Rebuild spans using DOM API (e.g. after ajax-cart.js clobbers them)
        btn.textContent = '';
        var spanText = document.createElement('span');
        spanText.className = 'v2-atc-text';
        spanText.textContent = label;
        var spanQty = document.createElement('span');
        spanQty.className = 'v2-atc-qty';
        spanQty.textContent = qtyLabel;
        var spanTotal = document.createElement('span');
        spanTotal.className = 'v2-cart-total';
        spanTotal.textContent = '$' + total;
        btn.appendChild(spanText);
        btn.appendChild(spanTotal);
        btn.appendChild(spanQty);
      }

      if (_atcObserver && _atcObserverBtn) {
        _atcObserver.observe(_atcObserverBtn, _atcObserverConfig);
      }
      _isATCUpdating = false;
    }

    // Update hidden price container for ajax-cart.js compatibility
    if (_els.selectedPrice) _els.selectedPrice.textContent = '$' + unitPrice.toFixed(2);

    if (_els.oldPrice) _els.oldPrice.textContent = '$' + data.base.toFixed(2);

    if (_els.purchaseLabel) _els.purchaseLabel.textContent = sub ? 'Monthly' : 'One-Time';
  }

  // ── Bind-once helper ──
  // Elements inside the buy box are replaced wholesale on a swap, so fresh
  // nodes always bind; the flag only stops a repeat init on the SAME nodes
  // from stacking handlers.
  function bindOnce(el, event, handler) {
    if (el.dataset.v2Bound) return;
    el.dataset.v2Bound = '1';
    el.addEventListener(event, handler);
  }

  // ── A. Purchase Card Bridge ──
  function initPurchaseCards() {
    var cards = document.querySelectorAll('.v2-purchase-card');
    cards.forEach(function (card) {
      bindOnce(card, 'click', function (e) {
        // Don't trigger if clicking the frequency dropdown or learn link
        if (e.target.closest('.v2-frequency-selector') || e.target.closest('.v2-learn-link')) return;

        var type = this.getAttribute('data-type');

        // Update v2 visual state
        cards.forEach(function (c) { c.classList.remove('selected'); });
        this.classList.add('selected');

        // Toggle quantity badge/footer visibility
        var qtySection = document.querySelector('.v2-quantity-section');
        if (qtySection) {
          if (type === 'one-time') {
            qtySection.classList.add('v2-onetime-mode');
          } else {
            qtySection.classList.remove('v2-onetime-mode');
          }
        }

        // Bridge: trigger the hidden radio that ajax-cart.js listens on
        var hiddenRadio = document.querySelector('.purchase-type-radio-buttons input[data-type="' + type + '"]');
        if (hiddenRadio) {
          hiddenRadio.checked = true;
          hiddenRadio.click();
        }

        // Sync selling plan state immediately.
        // The MutationObserver in initFormGuard() handles any subsequent
        // ReCharge re-injections automatically, and the submit guard
        // ensures correct state at form submission.
        syncSellingPlan(type);
        updateAllPrices();
      });
    });
  }

  // ── B. Quantity Card Selection ──
  function initQuantityCards() {
    var cards = document.querySelectorAll('.v2-qty-card');
    cards.forEach(function (card) {
      bindOnce(card, 'click', function () {
        cards.forEach(function (c) { c.classList.remove('selected'); });
        this.classList.add('selected');

        var qty = parseInt(this.getAttribute('data-qty'), 10);
        var qtyInput = document.getElementById('Quantity');
        if (qtyInput) qtyInput.value = qty;

        updateAllPrices();
      });
    });
  }

  // ── C. Frequency Display Bridge ──
  function initFrequency() {
    var display = document.querySelector('.v2-frequency-display');
    var dropdown = document.querySelector('.v2-frequency-dropdown');
    if (!display || !dropdown) return;

    // Toggle dropdown on display click
    bindOnce(display, 'click', function (e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
      display.classList.toggle('open');
    });

    // Close dropdown when clicking outside — bound once for the page
    // lifetime, looked up live so it survives buy-box swaps.
    if (!_docCloseBound) {
      _docCloseBound = true;
      document.addEventListener('click', function () {
        var dd = document.querySelector('.v2-frequency-dropdown');
        var dp = document.querySelector('.v2-frequency-display');
        if (dd) dd.classList.remove('open');
        if (dp) dp.classList.remove('open');
      });
    }

    // Frequency option click
    var options = document.querySelectorAll('.v2-freq-option');
    options.forEach(function (opt) {
      bindOnce(opt, 'click', function (e) {
        e.stopPropagation();
        var freq = this.getAttribute('data-freq');

        // Update display text
        var displayMap = {
          'Monthly': '1 Month',
          'Every 3-Months': '3 Months',
          'Every 5-Months': '5 Months'
        };
        var freqValue = document.querySelector('.v2-freq-value');
        if (freqValue) freqValue.textContent = displayMap[freq] || freq;

        // Update selected state
        options.forEach(function (o) { o.classList.remove('selected'); });
        this.classList.add('selected');

        // Close dropdown
        dropdown.classList.remove('open');
        display.classList.remove('open');

        // Bridge: trigger hidden frequency-select-menu-option click
        var hiddenOptions = document.querySelectorAll('.frequency-wrapper .frequency-select-menu-option');
        hiddenOptions.forEach(function (hiddenOpt) {
          if (hiddenOpt.textContent.trim() === freq) {
            hiddenOpt.click();
          }
        });

        // Sync the selling plan dropdown immediately.
        // MutationObserver handles any RC re-injections.
        syncSellingPlanFrequency(freq);
        syncSellingPlan('subscription');
      });
    });
  }

  // ── D. Flavor Pill → Thumbnail Carousel Swap ──
  // Thumbnails are 5 per flavor. Map each pill index to its thumbnail range.
  function initFlavorPills() {
    var pills = document.querySelectorAll('.v2-flavor-pill');
    var thumbItems = document.querySelectorAll('#ProductThumbs .thumbnail-image');
    var mainImg = document.getElementById('ProductPhotoImg');
    var imagesPerFlavor = thumbItems.length > 0 ? Math.floor(thumbItems.length / pills.length) : 5;

    function showMainFromThumb(thumb) {
      if (!mainImg || !thumb) return;
      var link = thumb.querySelector('a');
      var thumbImg = thumb.querySelector('img');
      if (link && link.getAttribute('href')) {
        mainImg.setAttribute('src', link.getAttribute('href'));
      }
      if (thumbImg && thumbImg.getAttribute('alt')) {
        mainImg.setAttribute('alt', thumbImg.getAttribute('alt'));
      }
      mainImg.style.display = 'block';
    }

    function showFlavorRange(pillIndex) {
      var startIdx = pillIndex * imagesPerFlavor;
      thumbItems.forEach(function (thumb, i) {
        thumb.style.display = (i >= startIdx && i < startIdx + imagesPerFlavor) ? 'inline-block' : 'none';
      });
      showMainFromThumb(thumbItems[startIdx]);
    }

    pills.forEach(function (pill, pillIndex) {
      bindOnce(pill, 'click', function () {
        // Update hidden variant select
        var variantId = this.getAttribute('data-id');
        var productSelect = document.getElementById('productSelect');
        if (productSelect) productSelect.value = variantId;

        showFlavorRange(pillIndex);
      });
    });

    // Set initial state: sync pill selection with the hidden <select> value
    // (Shopify sets selected_or_first_available_variant on page load)
    if (pills.length > 0 && thumbItems.length > 0) {
      var productSelect = document.getElementById('productSelect');
      var activeVariantId = productSelect ? productSelect.value : null;
      var activeIndex = 0;

      pills.forEach(function (pill, i) {
        pill.classList.remove('selected');
        if (activeVariantId && pill.getAttribute('data-id') === activeVariantId) {
          activeIndex = i;
        }
      });
      pills[activeIndex].classList.add('selected');
      showFlavorRange(activeIndex);
    } else if (mainImg) {
      mainImg.style.display = 'block';
    }
  }

  // ── E. Guard ATC button from ajax-cart.js overwrites ──
  function guardATCButton() {
    var btn = _els.atcBtn;
    if (!btn) return;

    // Drop any observer from a previous init before observing the
    // (possibly new) button, so re-inits never stack observers.
    if (_atcObserver) _atcObserver.disconnect();

    _atcObserverBtn = btn;
    _atcObserver = new MutationObserver(function () {
      // Skip if updateAllPrices is already writing to the DOM (re-entrancy guard)
      if (_isATCUpdating) return;
      // If ajax-cart.js replaced our spans with plain text, restore them
      if (!btn.querySelector('.v2-atc-text')) {
        updateAllPrices();
      }
    });

    _atcObserver.observe(btn, _atcObserverConfig);
  }

  // ── F. Form Guard ──
  // MutationObserver watches for ReCharge widget injecting selling_plan
  // elements and neutralizes them immediately. This replaces the previous
  // approach of cascading setTimeout re-syncs (200ms, 500ms, 1500ms).
  // The submit listener provides a final safety net before form serialization.
  function initFormGuard() {
    var form = _els.form;
    if (!form) return;

    function hasSPElement(node) {
      if (node.nodeType !== 1) return false;
      var name = node.getAttribute && node.getAttribute('name') || '';
      if (name === 'selling_plan' || name.indexOf('selling_plan_') === 0) return true;
      if (node.querySelectorAll) {
        var matches = node.querySelectorAll('[name="selling_plan"], [name^="selling_plan_"]');
        if (matches.length > 0) return true;
      }
      return false;
    }

    // Drop any observer from a previous init before observing the
    // (possibly new) form, so re-inits never stack observers.
    if (_formGuardObserver) _formGuardObserver.disconnect();

    _formGuardObserver = new MutationObserver(function (mutations) {
      var dominated = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (hasSPElement(node)) dominated = true;
        });
      });
      if (dominated) {
        var currentType = isSubscribe() ? 'subscription' : 'one-time';
        syncSellingPlan(currentType);
      }
    });
    _formGuardObserver.observe(form, { childList: true, subtree: true });

    // Final cleanup right before form serialization
    if (!form.dataset.v2SubmitGuard) {
      form.dataset.v2SubmitGuard = '1';
      form.addEventListener('submit', function () {
        var currentType = isSubscribe() ? 'subscription' : 'one-time';
        syncSellingPlan(currentType);
      });
    }
  }

  // ── G. Initialization ──
  // Safe to call again after the buy-box subtree is swapped: the element
  // cache is rebuilt, observers are re-attached to the new nodes, and
  // per-element bind flags keep handlers from stacking.
  function init() {
    // Pick up the pricing object published by the current buy box
    PRICING = window.V2_PRICING || {};

    // Populate cached DOM references for static elements
    _els.atcBtn          = document.getElementById('AddToCart');
    _els.selectedPrice   = document.querySelector('.price-container .product-selected-price');
    _els.oldPrice        = document.querySelector('.price-container .old-price');
    _els.purchaseLabel   = document.querySelector('.price-container .purchase-type-label');
    _els.form            = document.getElementById('AddToCartForm');
    _els.ourSelect       = _els.form ? _els.form.querySelector('select.rc-selling-plans__dropdown') : null;

    initPurchaseCards();
    initQuantityCards();
    initFrequency();
    initFlavorPills();
    initFormGuard();

    // Set initial prices
    updateAllPrices();

    // Guard the ATC button against external overwrites
    guardATCButton();

    // Initialize subscription state: click the hidden radio to tell
    // ajax-cart.js and ReCharge that we want subscription mode.
    // initFormGuard's MutationObserver handles any RC re-injections.
    var subRadio = document.querySelector('.purchase-type-radio-buttons input[data-type="subscription"]');
    if (subRadio) {
      subRadio.checked = true;
      subRadio.click();
    }
    syncSellingPlan('subscription');
  }

  document.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('.v2-assurance__truemed');
    if (!link) return;
    var opener = document.querySelector('.truemed-instructions-open');
    if (!opener) return;
    e.preventDefault();
    opener.click();
  });

  // Expose for re-initialization after an in-page buy-box swap
  // (see assets/subscribe-product-toggle.js)
  window.ProductV2 = window.ProductV2 || {};
  window.ProductV2.init = init;

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
